module.exports = __webpack_public_path__ + "static/img/logo-grey.5df10f8f.png";